'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />
/* tslint:disable:no-unused-variable member-ordering */
var API;
(function (API) {
    var Client;
    (function (Client) {
        'use strict';

        var SellersApi = function () {
            function SellersApi($http, $httpParamSerializer, basePath) {
                _classCallCheck(this, SellersApi);

                this.$http = $http;
                this.$httpParamSerializer = $httpParamSerializer;
                this.basePath = '/proxy/oag/gtw_rh';
                this.defaultHeaders = {};
                if (basePath) {
                    this.basePath = basePath;
                }
            }

            _createClass(SellersApi, [{
                key: 'extendObj',
                value: function extendObj(objA, objB) {
                    for (var key in objB) {
                        if (objB.hasOwnProperty(key)) {
                            objA[key] = objB[key];
                        }
                    }
                    return objA;
                }
                /**
                 *
                 *
                 * @param branchCodeCVC
                 * @param saleTypeCode
                 * @param agencyCode
                 */

            }, {
                key: 'sellerGet',
                value: function sellerGet(branchCodeCVC, saleTypeCode, saleSystem, agencyCode, extraHttpRequestParams) {
                    var localVarPath = this.basePath + '/seller';
                    var queryParameters = {};
                    var headerParams = this.extendObj({}, this.defaultHeaders);
                    // verify required parameter 'branchCodeCVC' is set
                    if (!branchCodeCVC) {
                        throw new Error('Missing required parameter branchCodeCVC when calling sellerGet');
                    }
                    // verify required parameter 'saleTypeCode' is set
                    if (!saleTypeCode) {
                        throw new Error('Missing required parameter saleTypeCode when calling sellerGet');
                    }
                    // verify required parameter 'saleSystem' is set
                    if (!saleSystem) {
                        throw new Error('Missing required parameter saleSystem when calling sellerGet');
                    }
                    if (branchCodeCVC !== undefined) {
                        queryParameters['branchCodeCVC'] = branchCodeCVC;
                    }
                    if (saleTypeCode !== undefined) {
                        queryParameters['saleTypeCode'] = saleTypeCode;
                    }
                    if (saleSystem !== undefined) {
                        queryParameters['saleSystem'] = saleSystem;
                    }
                    if (agencyCode !== undefined) {
                        queryParameters['agencyCode'] = agencyCode;
                    }
                    var httpRequestParams = {
                        method: 'GET',
                        url: localVarPath,
                        json: true,
                        params: queryParameters,
                        headers: headerParams
                    };
                    if (extraHttpRequestParams) {
                        httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
                    }
                    return this.$http(httpRequestParams);
                }
            }]);

            return SellersApi;
        }();

        SellersApi.$inject = ['$http', '$httpParamSerializer'];
        Client.SellersApi = SellersApi;
    })(Client = API.Client || (API.Client = {}));
})(API || (API = {}));